export default "__VITE_ASSET__588edaab__"